module.exports = __webpack_public_path__ + "img/xdyl.92323694.png";